import { UserFriendlyError } from "../../../../../common/utils/base_error";
import { FileUtils } from "../../../../../common/utils/file_utils";
import { IUpdateMaquinaEquipArquivoUseCase } from "../../../presentation/useCases/update/update_maquina_equip_arquivo_use_case";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

export class UpdateMaquinaEquipArquivoUseCase implements IUpdateMaquinaEquipArquivoUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) {}

  async updateMaquinaEquipArquivo(
    idMaquinaEquipArquivo: number,
    idMaquinaEquip: number,
    descricao: string,
    arquivo: File | null,
    limparArquivo: boolean,
  ): Promise<void> {
    if (limparArquivo === true && arquivo === null)
      throw new UserFriendlyError("O arquivo é obrigatório!");

    const arquivoNome =
      arquivo !== null && arquivo !== undefined
        ? await this.getFilename(arquivo)
        : null;

    await this.repository.updateControledePatrimonioMaquinaEquipArquivo(
      idMaquinaEquipArquivo,
      idMaquinaEquip,
      descricao,
      arquivoNome,
      arquivo,
      limparArquivo,
    );
  }

  private async getFilename(file: File | null): Promise<string | null> {
    if (file === null) return null;
    return file.name;
  }
}
